export default {
  en: {
    progressLabel: 'Onboarding step',
    back: '← Back',
  },
  ru: {
    progressLabel: 'Шаг онбординга',
    back: '← Назад',
  },
  de: {
    progressLabel: 'Onboarding-Schritt',
    back: '← Zurück',
  },
  pt: {
    progressLabel: 'Etapa do onboarding',
    back: '← Voltar',
  },
  fr: {
    progressLabel: 'Étape d’onboarding',
    back: '← Retour',
  },
  es: {
    progressLabel: 'Paso del onboarding',
    back: '← Atrás',
  },
};
